const paths = {
  protocolsList: '/listProtocol',
  consolesList: '/listConsoles'
};

export default paths;
